import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ReferenceLine, ResponsiveContainer } from "recharts";

const SERIES = [
  { key: "created", name: "New", color: "#183E6C", width: 2 },
  { key: "resolved", name: "Resolved", color: "#0a7d43", width: 2 },
  { key: "breached", name: "SLA breaches", color: "#A11E21", width: 2.5 },
];
const CHART_MARGIN = { top: 8, right: 12, left: -18, bottom: 0 };
const TICK_STYLE = { fontSize: 10 };
const TOOLTIP_STYLE = { fontSize: 12, borderRadius: 2 };
const LEGEND_STYLE = { fontSize: 11 };
const DOT = { r: 2.5 };
const ACTIVE_DOT = { r: 4 };
const REF_LABEL = { value: "selected", fontSize: 9, fill: "#A11E21", position: "insideTopRight" };
const TREND_PARAMS = { params: { weeks: 12 } };
const weekLabel = (l) => `Week of ${l}`;

export function DigestTrend({ selectedWeek }) {
  const [weeks, setWeeks] = useState(null);
  useEffect(() => { api.get("/tickets/digests/trend", TREND_PARAMS).then((r) => setWeeks(r.data.weeks)).catch((e) => { console.error("digest trend", e); setWeeks([]); }); }, []);
  if (!weeks) return <div className="h-44 border border-border rounded-sm animate-pulse bg-secondary/40" data-testid="digest-trend-loading" />;
  const sel = weeks.find((w) => w.week_start === selectedWeek);
  const sums = SERIES.map((s) => weeks.reduce((a, w) => a + w[s.key], 0));
  return (
    <div className="border border-border rounded-sm p-3" data-testid="digest-trend">
      <div className="flex items-baseline gap-2 mb-1">
        <span className="text-sm font-semibold">12-week trend</span>
        <span className="text-[11px] text-muted-foreground" data-testid="digest-trend-summary">{sums[0]} new · {sums[1]} resolved · {sums[2]} breaches over 12 weeks</span>
      </div>
      <div className="h-44 min-w-0">
        <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={1}>
          <LineChart data={weeks} margin={CHART_MARGIN}>
            <CartesianGrid strokeDasharray="3 3" stroke="currentColor" className="text-border" vertical={false} />
            <XAxis dataKey="label" tick={TICK_STYLE} tickLine={false} axisLine={false} interval={1} />
            <YAxis allowDecimals={false} tick={TICK_STYLE} tickLine={false} axisLine={false} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelFormatter={weekLabel} />
            <Legend iconType="plainline" wrapperStyle={LEGEND_STYLE} />
            {sel && <ReferenceLine x={sel.label} stroke="#A11E21" strokeDasharray="4 3" label={REF_LABEL} />}
            {SERIES.map((s) => <Line key={s.key} type="monotone" dataKey={s.key} name={s.name} stroke={s.color} strokeWidth={s.width} dot={DOT} activeDot={ACTIVE_DOT} isAnimationActive={false} />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
